const update = require('immutability-helper')

const mapPropertiesToMutateObject = require('./utils/mapPropertiesToMutateObject');
const { pageView, channel, user, basic } = require('./default-properties')

const defaultProperties = {
  ...pageView,
  ...channel,
  ...user,
  ...basic,
};

function pageviewProperties(properties = {}, globalProperties = {}) {
  const propertiesToMutate = mapPropertiesToMutateObject(properties, globalProperties)
  return update(defaultProperties, propertiesToMutate);
};


function validate() {
  // For event validation later
}

module.exports = {
  pageviewProperties,
  validate,
}